export default "__VITE_ASSET__D6yCV8nS__"